module.exports = __webpack_public_path__ + "static/media/galeryFloating8.c990549b.jpg";